import type { JourneyState, UserProfile } from '../types'

const AUDIO_URL = 'https://commons.wikimedia.org/wiki/Special:Redirect/file/Ludwig%20van%20Beethoven%20-%20symphony%20no.%205%20in%20c%20minor%2C%20op.%2067%20-%20i.%20allegro%20con%20brio.ogg'

export const demoUser: UserProfile = {
  id: 'demo-user',
  name: 'Marina',
  email: 'ouvinte@demo.local',
  intention: 'Entender melhor o que escuto',
  experience: 'Curiosa, mas sem formação musical',
  preferredTime: '20:00',
  notifications: true,
  onboardingComplete: true,
}

export function createDemoJourney(): JourneyState {
  const started = new Date(Date.now() - 1000 * 60 * 3)
  const unlock2 = new Date(started.getTime() + 1000 * 60 * 2)
  const unlock3 = new Date(started.getTime() + 1000 * 60 * 4)

  return {
    serverNow: new Date().toISOString(),
    cadenceLabel: 'Ciclo-piloto · 7 dias simulados em 4 minutos',
    cycleId: 'demo-cycle',
    userCycleId: 'demo-user-cycle',
    work: {
      id: 'beethoven-5',
      title: 'Sinfonia nº 5 em dó menor',
      composer: 'Ludwig van Beethoven',
      year: '1808',
      subtitle: 'I. Allegro con brio · Op. 67',
      duration: '8 min',
      audioUrl: AUDIO_URL,
      license: 'Domínio público',
      attribution: 'Skidmore College Orchestra · Musopen / Wikimedia Commons',
      accent: '#983bf6',
    },
    activities: [
      {
        id: 'discover', order: 1, kind: 'discovery', eyebrow: 'Primeiro encontro',
        title: 'Escute sem tentar acertar', description: 'Uma escuta inteira para notar o que chama você.',
        duration: '8 min', unlockAt: started.toISOString(), status: 'available', progressSeconds: 0,
        content: {
          intro: 'Sem nomes técnicos por enquanto. Deixe o começo atravessar você e repare no que retorna.',
          prompt: 'Que imagem, sensação ou movimento apareceu primeiro?',
          transcript: [
            { at: 0, title: 'Um gesto que bate à porta', text: 'Quatro notas curtas criam uma pergunta que a orquestra inteira passará a perseguir.' },
            { at: 48, title: 'A ideia se espalha', text: 'O motivo deixa de ser uma frase isolada e passa de instrumento em instrumento.' },
            { at: 132, title: 'Contraste', text: 'Uma segunda ideia abre espaço, mas a pulsação inquieta continua por baixo.' },
          ],
        },
      },
      {
        id: 'guided', order: 2, kind: 'guided', eyebrow: 'Escuta guiada',
        title: 'Siga a ideia de quatro notas', description: 'Volte à obra com três pontos de atenção.',
        duration: '10 min', unlockAt: unlock2.toISOString(), status: 'locked', progressSeconds: 0,
        content: {
          intro: 'Agora você já conhece o terreno. Vamos ouvir como uma célula mínima organiza todo o movimento.',
          prompt: 'Depois de seguir o motivo, o começo pareceu diferente?',
          transcript: [
            { at: 0, title: '0:00 · O motivo', text: 'Curto-curto-curto-longo. Não é um código: é matéria rítmica em transformação.' },
            { at: 67, title: '1:07 · Resposta e tensão', text: 'As cordas repetem e deslocam o gesto; os sopros abrem outra cor.' },
            { at: 238, title: '3:58 · O retorno', text: 'Quando o tema volta, ele carrega tudo o que aconteceu no caminho.' },
          ],
        },
      },
      {
        id: 'botelho', order: 3, kind: 'botelho', eyebrow: 'Aprofundando',
        title: 'Por que esse começo não nos solta?', description: 'Uma conversa curta para fechar — e reabrir — sua escuta.',
        duration: '4 min', unlockAt: unlock3.toISOString(), status: 'locked', progressSeconds: 0,
        content: {
          intro: 'Você ouviu primeiro. Agora vem a companhia: contexto sem tirar de você o prazer da descoberta.',
          botelhoNote: 'Beethoven não nos entrega uma melodia confortável; entrega um gesto. É por isso que a Quinta parece começar antes mesmo de estarmos prontos. As quatro notas não significam uma coisa só. Elas funcionam como uma pergunta insistente, capaz de assumir muitas cores sem perder a identidade.',
          prompt: 'O que você aprendeu com as escutas dessa música?',
        },
      },
    ],
    waitContent: {
      title: 'Deixe a obra trabalhar um pouco.',
      text: 'A pausa faz parte da experiência. Você não está atrasada: o próximo encontro chega no tempo do ciclo.',
      question: 'Se o começo da Quinta fosse um movimento do corpo, qual seria?',
    },
  }
}
